<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <liberacao-detalhe :solicitacao="solicitacao"></liberacao-detalhe>
              <div v-if="!aprovada">
                <div v-if="habilitaTributacao" class="row">
                  <div class="col-md-4">
                    <b-form-group label="Tributação Inicial" label-for="eco_tributacao">
                      <select id="eco_tributacao"
                              v-model="solicitacao.economico.eco_tributacao"
                              class="custom-select"
                              :class="{'is-invalid': $v.historico.chm_status.$error}"
                              type="text">
                        <option value="1">Microempreendedor Individual (MEI)</option>
                        <option value="2">Empresa Simples Nacional</option>
                        <option value="">Sem Tributação</option>
                      </select>
                      <div v-if="$v.historico.chm_status.$error" class="invalid-feedback">
                        Selecione um status
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group label="Status" label-for="chm_status">
                      <select id="chm_status"
                              v-model="historico.chm_status"
                              class="custom-select"
                              :class="{'is-invalid': $v.historico.chm_status.$error}"
                              type="text">
                        <option value=""></option>
                        <option value="2">Em Andamento</option>
                        <option value="3">Pendente de Alterações</option>
                        <option value="4">Rejeitado/Cancelado</option>
                        <option value="9">Aprovado</option>
                      </select>
                      <div v-if="$v.historico.chm_status.$error" class="invalid-feedback">
                        Selecione um status
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="'" class="text-white mt-2" label-for="eco_substituicao">
                      <b-form-checkbox
                          id="eco_substituicao"
                          v-model="solicitacao.economico.eco_substituicao"
                          v-bind:disabled="historicoMarcado"
                          :value="true"
                          :unchecked-value="false"
                          class="custom-checkbox text-dark custom-checkbox-outline custom-checkbox-primary mb-3">
                        Substituto Tributário
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div v-if="historico.chm_status !=='9'" class="row">
                <div v-if="!aprovada" class="col-md-12">
                  <b-form-group label="Detalhe da análise" label-for="chm_motivo">
                  <textarea name="textarea" v-model="historico.chm_motivo"
                            :class="{'is-invalid': $v.historico.chm_motivo.$error}"
                            rows="3" id="chm_motivo"
                            class="form-control"></textarea>
                    <div v-if="$v.historico.chm_motivo.$error" class="invalid-feedback">
                      Informe o conteúdo da análise
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button"
                          @click="saveHistorico"
                          v-if="!aprovada"
                          class="btn btn-label btn-success mr-3">
                    <i class="bx bx-check-double label-icon"></i> Salvar
                  </button>
                  <button @click="relSolicitacao()" type="button"
                          class="btn btn-label mr-3 btn-info">
                    <i class="bx bx-file label-icon"></i>
                    Cartão
                  </button>
                  <button type="button" @click="fechar()" class="btn btn-label btn-light"><i
                      class="bx bx-exit label-icon"></i> Voltar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <historico-movimento
              :historico="solicitacao.historico_movimentacao">
          </historico-movimento>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader";
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import HistoricoMovimento from "@/components/geral/historico-movimento"
import LiberacaoDetalhe from "@/router/views/contribuinte/components/liberacao-detalhe"
import {getSolicitacao} from "@/api/solicitacao/pessoa";
import {setHistoricoMovimento} from "@/api/admin/liberacao/pessoa";
import {impressao} from "@/helps/impressao";
import {setRelSolicitacaoCadastro} from "@/api/relatorio/contribuinte";
import moment from "moment";
import {notifySucesso, notifyErro} from "@/helps/notificacao";

export default {
  page: {
    title: "Solicitação",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    HistoricoMovimento,
    LiberacaoDetalhe
  },
  data() {
    return {
      title: "Solicitação",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
      httpSend: false,
      aprovada: false,
      habilitaTributacao: false,
      solicitacao: {
        pessoa: {
          tps_cpf_cnpj: '',
          tps_natureza_juridica: {
            naj_referencia: '',
          },
        },
        economico: {
          tec_contador_proprio: '',
          eco_substituicao: '',
          eco_tributacao: '',
        },
        usuario: {
          pes_nome: ''
        },
        historico_movimentacao: [],
      },
      historico: {
        ceh_codigo: null,
        chm_status: '',
        chm_motivo: '',
        eco_substituicao: null,
      },
      historicoMarcado: false,
    };
  },
  validations: {
    historico: {
      chm_status: {
        required,
      },
      chm_motivo: {
        required,
      },
    },
  },
  created() {
    this.getSocilitacao();
  },
  methods: {
    verificaTributacao() {
      const hoje = moment();
      const abertura = moment(this.solicitacao.pessoa.tps_data_abertura_nascimento, 'YYYY-MM-DD');
      const dias = hoje.diff(abertura, 'days');
      if (dias < 30) {
        this.habilitaTributacao = true;
      }
    },
    getSocilitacao() {
      this.httpSend = true;
      getSolicitacao(this.$route.params.tps_hash).then(response => {
        if (response.status) {
          this.solicitacao = response.dados
          if (this.solicitacao.historico_movimentacao && this.solicitacao.historico_movimentacao[0]) {
            this.aprovada = (this.solicitacao.historico_movimentacao[0].chm_status === '9');
          }
          for (const s of this.solicitacao.servicos) {
            if (s.sre_substituicao === 'S') {
              this.historicoMarcado = true;
              this.solicitacao.economico.eco_substituicao = true;
            }
          }
          this.verificaTributacao();
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveHistorico() {
      if (this.historico.chm_status !== '9') {
        this.$v.historico.$touch();
        if (this.$v.historico.$invalid) {
          return false
        }
      }
      this.historico.ceh_codigo = this.solicitacao.historico.ceh_codigo;
      this.historico.eco_substituicao = this.solicitacao.economico.eco_substituicao;
      this.historico.tps_cpf_cnpj = this.solicitacao.pessoa.tps_cpf_cnpj;
      if (this.habilitaTributacao) {
        this.historico.eco_tributacao = this.solicitacao.economico.eco_tributacao
      }
      this.httpSend = true;
      setHistoricoMovimento(this.historico).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.historico.chm_motivo = '';
          this.getSocilitacao();
        } else {
          notifyErro("DattaNFSe", response.mensagem)
        }
      }).catch(error => {
        notifyErro("DattaNFSe", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    relSolicitacao() {
      this.httpSend = true;
      impressao(setRelSolicitacaoCadastro(this.$route.params.tps_hash), 'D').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    fechar() {
      this.$router.push({name: 'admin-liberacao-pessoa'})
    },
  },
};
</script>


